import {
  AppCard,
  Button,
} from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { Box, Container, Typography, useColorScheme } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import equinorLogoHorizontal from "../../../images/equinor-logo-horizontal.svg";

const NEW_DOMAIN = "sellto.equinor.com" as const;
const OLD_DOMAIN = "br.sellto.equinor.com" as const;
const REDIRECT_DELAY_MS = 10000;

const RouteComponent: React.FC = () => {
  const { t } = useTranslation();
  const { mode: themeMode, systemMode: themeSystemMode } = useColorScheme();

  const [remainTime, setRemainTime] = useState(REDIRECT_DELAY_MS);

  useEffect(() => {
    const interval = setInterval(() => {
      if (remainTime <= 0) {
        clearInterval(interval);
        return;
      }

      setRemainTime((prevTime) => prevTime - 1000);
    }, 1000);

    return () => clearInterval(interval);
  }, [remainTime]);

  useEffect(() => {
    if (remainTime <= 0) {
      window.location.href = `https://${NEW_DOMAIN}`;
    }
  }, [remainTime]);

  return (
    <Container
      maxWidth="md"
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "0px !important",
      }}
    >
      <AppCard slotProps={{ root: { sx: { padding: 4 } } }}>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            gap: 4,
          }}
        >
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              alt="Equinor logo"
              src={`${equinorLogoHorizontal}#${(themeSystemMode ?? themeMode) === "dark" ? "white" : "red"}`}
              style={{ width: "240px" }}
            />
          </Box>

          <Typography variant="h3">{t("domainTransition.header")}</Typography>

          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography>
              <Trans
                i18nKey="domainTransition.message"
                t={t}
                values={{
                  newDomain: NEW_DOMAIN,
                  oldDomain: OLD_DOMAIN,
                }}
              />
            </Typography>

            <Typography>
              {t("domainTransition.redirectNotice", {
                remainTime: remainTime / 1000,
              })}
            </Typography>

            <Typography>
              <Trans i18nKey="domainTransition.updateBookmarksMessage" t={t} />
            </Typography>
          </Box>

          <Button fullWidth href={`https://${NEW_DOMAIN}`}>
            {t("domainTransition.redirectButton")}
          </Button>
        </Box>
      </AppCard>
    </Container>
  );
};

export const Route = createFileRoute("/_public/domain_transition")({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        content: `${REDIRECT_DELAY_MS / 1000};url=https://${NEW_DOMAIN}`,
        httpEquiv: "refresh",
      },
      {
        title: "Estamos de mudança - Sell To Equinor | Brasil",
      },
    ],
  }),
});
